var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ee-select-modal"},[_c('div',{staticClass:"ee-select-modal-content"},[_c('model-list',{on:{"change-model":_vm.changeModel}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }